import React, { useEffect, useState } from 'react'
import { Link, Outlet } from 'react-router-dom'
import Table from '../../Components/Script/Table'
import { createrole, GetAllRole } from '../../Services/userProfile';

function CreateRole() {
    const [roles, setRoles] = useState([]);
    const [RoleName, setRoleName] = useState('');
    const user = JSON.parse(localStorage.getItem("user"));

    // State to store roles

    useEffect(() => {
        fetchAllRoles();  // Fetch roles when the component is mounted
    }, []);

    const handleSubmit = async (e) => {
            e.preventDefault();
            const formData = {
                userId:user.id,
                name:RoleName  // Send the current user ID or another identifier for createdBy
            };
    
            try {
                await createrole(formData);  // Call the createUser API to insert the user
                // alert('User created successfully');
                // You may want to redirect or refresh the user list
                fetchAllRoles();
                setRoleName('');
            } catch (error) {
                console.error('Error creating user:', error);
                alert('User creation failed');
            }
        };

    const fetchAllRoles = async () => {
        try {
            const rolesData = await GetAllRole();
            setRoles(rolesData);  // Set roles in state
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };
    return (
        <div>
            <Table />

            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">User</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">User</h4>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="row g-2">
                                                    <div className="mb-3 col-md-4">
                                                        <label htmlFor="inputRole" className="form-label">Role Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="inputUserName"
                                                            value={RoleName}
                                                            onChange={(e) => setRoleName(e.target.value)}
                                                            placeholder="User Name"
                                                        />
                                                    </div>
                                                </div>
                                                <button type="submit" className="btn btn-primary">Submit</button>
                                            </form>
                                        </div> {/* end card body*/}
                                    </div> {/* end card */}
                                </div>{/* end col*/}
                            </div> {/* end row*/}

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="tab-content">
                                                <div className="tab-pane show active" id="fixed-columns-preview">

                                                    <div className="table-responsive">
                                                        <table id="fixed-columns-datatable" className="table table-striped table-bordered table-hover nowrap row-border order-column w-100">
                                                            <thead>
                                                                <tr>
                                                                    <th>Sr. No.</th>
                                                                    <th>Role Name</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {roles.length > 0 ? (
                                                                    roles.map((user) => (
                                                                        <tr key={user.id}>
                                                                            <td>{user.id}</td>
                                                                            <td>{user.name}</td>


                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="8" className="text-center">No Data Found</td>
                                                                    </tr>
                                                                )}


                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div> {/* end preview*/}
                                            </div> {/* end tab-content*/}
                                        </div> {/* end card body*/}
                                    </div> {/* end card */}
                                </div>{/* end col*/}
                            </div> {/* end row*/}
                        </div>
                    </div>
                </div>
            </div>
            <Outlet />
        </div>
    )
}

export default CreateRole
